// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ir1d","header":"PatientQuestionnaire_header__2KCPl","info":"PatientQuestionnaire_info__1qtxv"};